import React from "react";
import { connect } from "react-redux";
import { getPendingTaskLineItems, getPendingTask } from "../Actions/ShipViewAPI";
import { DownloadDocument } from "../Actions/CommonAPI";
import moment from "moment";

class StaffPOValidation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            PendingTaskPODetail: null
        };

    }

    componentDidMount() {
        const { dispatch, match, history } = this.props;
        const { params } = match;
        const { shipId, poId } = params;
        dispatch(getPendingTask(shipId, 1));
        dispatch({ type: 'SubBannerTitle', data: "Staff PO Validation" });
        dispatch(getPendingTaskLineItems(poId));
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const { PendingTasks, match } = nextProps;
        const { params } = match;
        const { shipId, poId } = params;
        let taskArray = [];
        if (PendingTasks.data && PendingTasks.data.length) {
            taskArray = PendingTasks.data.filter(r => { return r.purchaseOrderId === parseInt(poId) })
            prevState.PendingTaskPODetail = JSON.parse(JSON.stringify(Object.assign({}, taskArray[0])));
        }
    }
    render() {
        const { ShowStaffPendingTaskPanel } = this.props;
        const { PendingTaskPODetail } = this.state;
        console.log("task", PendingTaskPODetail)
        return (
            <div className="pb-4">
                <div className="row mt-3">
                    <div className="col-lg-12">
                        <div className="panel-box">
                            <div className="px-4 py-2">
                                <div className="resource-list-auth-date">
                                    <div className="row">
                                        <div className="col-md-12 ">
                                            <div className="row">
                                                <div className={"col-sm-9 col-md-10 m-auto"}>
                                                    <div className="row">
                                                        <div className={ShowStaffPendingTaskPanel ? "col-md-6 py-1" : "col-md-4 py-1"}>
                                                            <h6 className="resource-list-title m-auto">
                                                                {PendingTaskPODetail ? PendingTaskPODetail.poNo : ""}
                                                            </h6>
                                                            {/* <span>
                                                                <strong>PO No : </strong>
                                                                <span className="italicFont ">{PendingTaskPODetail ? PendingTaskPODetail.poNo : ""}</span>
                                                            </span> */}
                                                        </div>
                                                        <div className={ShowStaffPendingTaskPanel ? "col-md-6 py-1" : "col-md-4 py-1"}>
                                                            <span>
                                                                <strong>PR No : </strong>
                                                                <span className="italicFont ">{PendingTaskPODetail ? PendingTaskPODetail.prNo : ""}</span>
                                                            </span>
                                                        </div>
                                                        <div className={ShowStaffPendingTaskPanel ? "col-md-6 py-1" : "col-md-4 py-1"}>
                                                            <span>
                                                                <strong>PO Date : </strong>
                                                                <span className="italicFont">{PendingTaskPODetail ? moment(PendingTaskPODetail.poDate).format("DD MMM YYYY") : ""}</span>
                                                            </span>
                                                        </div>
                                                        <div className={ShowStaffPendingTaskPanel ? "col-md-6 py-1" : "col-md-4 py-1"}>
                                                            <span>
                                                                <strong>Ship Name : </strong>
                                                                <span className="italicFont ">{PendingTaskPODetail ? PendingTaskPODetail.vesselName : ""}</span>
                                                            </span>
                                                        </div>
                                                        <div className={ShowStaffPendingTaskPanel ? "col-md-6 py-1" : "col-md-4 py-1"}>
                                                            <span>
                                                                <strong>Supplier Name  : </strong>
                                                                <span className="italicFont ">{PendingTaskPODetail ? PendingTaskPODetail.supplierName : ""}</span>
                                                            </span>
                                                        </div>
                                                        <div className={ShowStaffPendingTaskPanel ? "col-md-6 py-1" : "col-md-4 py-1"} style={{ wordBreak: "break-all" }}>
                                                            <span>
                                                                <strong>Supplier Email : </strong>
                                                                <span className="italicFont ">{PendingTaskPODetail ? PendingTaskPODetail.supplierEmail : ""}</span>
                                                            </span>
                                                        </div>
                                                        <div className="col-md-12 py-1">
                                                            <span>
                                                                <strong>PO Description : </strong>
                                                                <span className="italicFont ">{PendingTaskPODetail ? PendingTaskPODetail.poDescription : ""}</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={"col-sm-3 col-md-2 m-auto text-center"}>
                                                    <button class="btn btn-primary btn-xs btn-conf-edit ml-1" data-confirmation="confirm" style={{ width: "85px" }} onClick={() => this.poUpdateAll(PendingTaskPODetail)}>
                                                        Edit All
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-lg-12">
                        <div className="card MM-card-header" style={{ backgroundColor: "white" }}>
                            <div className="card-body">
                                <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                    Line Items
                                </h5>
                            </div>
                        </div>
                        <div className="p-0">
                            <div className="row">
                                <div className="col-md-12">
                                    {this.renderLineItemCard()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderLineItemCard() {
        const { PendingTaskLineItems } = this.props;
        return PendingTaskLineItems && PendingTaskLineItems.length
            ? PendingTaskLineItems.map((item, index) => {
                return (
                    <>
                        <div className="card" style={{ overflow: "hidden", position: "relative", marginBottom: '5px' }}>
                            <div className="px-4 py-2">
                                <div className="resource-list-auth-date">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-sm-9 col-md-10 m-auto">
                                                    <div className="row">
                                                        <div className="col-sm-12">
                                                            <h6 className="resource-list-title title m-auto mb-0" style={{ cursor: "pointer" }}>
                                                                {item ? item.itemDescription : ""}
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-3 col-md-2 m-auto text-center">
                                                    <button class="btn btn-primary btn-xs btn-conf-edit ml-1" data-confirmation="confirm" style={{ width: "85px" }} onClick={() => this.poUpdate(item)}>
                                                        Edit
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            }) :
            <div className="card" style={{ overflow: "hidden", position: "relative" }}>
                <div class="container">
                    <h6 className="resource-list-title no-item-card">
                        No Items
                </h6>
                </div>
            </div>;
    }
    downloadAttachment = (FileName, Guid) => {
        const { dispatch } = this.props;
        dispatch(DownloadDocument(FileName, Guid));
    }
    poUpdate(item) {
        const { match } = this.props;
        const { params } = match;
        const { shipId, poId } = params;
        this.props.dispatch({ type: "EditAllPO", data: false });
        this.props.dispatch({ type: "TaskDetails", data: item });
        this.props.dispatch({ type: "ShowStaffPendingTaskPanel", data: true });
        this.props.history.push(`/Home/Staff/POValidation/${shipId}/${poId}/update`);
    }
    poUpdateAll(item) {
        const { match } = this.props;
        const { params } = match;
        const { shipId, poId } = params;
        this.props.dispatch({ type: "EditAllPO", data: true });
        this.props.dispatch({ type: "TaskDetails", data: item });
        this.props.dispatch({ type: "ShowStaffPendingTaskPanel", data: true });
        this.props.history.push(`/Home/Staff/POValidation/${shipId}/${poId}/update`);
    }
}

function mapStateToProps(state) {
    return {
        PendingTaskLineItems: state.ShipViewReducer.PendingTaskLineItems,
        ShowStaffPendingTaskPanel: state.SidePanReducer.ShowStaffPendingTaskPanel || false,
        PendingTasks: state.ShipViewReducer.PendingTasks || [],
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(StaffPOValidation);
